import { getFnbReviewList } from '@/services/operations';
import { FNB_QUERY_KEYS } from '@/services/query-keys';
import { useQuery } from '@tanstack/react-query';

export const useFnbReviewList = (cstrShopNo: string) => {
    return useQuery({
        queryKey: FNB_QUERY_KEYS.fnbReviewList(cstrShopNo),
        queryFn: () => getFnbReviewList(cstrShopNo),
        enabled: !!cstrShopNo,
    });
};
